import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { IMAGES, PURCHASE_NAMES } from '../utils/constants';
export function PurchasePopup() {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    // Start showing popups after 10 seconds
    const initialDelay = setTimeout(() => {
      showRandomPopup();
    }, 10000);
    return () => {
      clearTimeout(initialDelay);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const showRandomPopup = () => {
    const randomPerson = PURCHASE_NAMES[Math.floor(Math.random() * PURCHASE_NAMES.length)];
    toast.custom(t => <div className="bg-white rounded-xl shadow-xl border border-gray-100 p-4 flex items-center gap-4 w-80 animate-in slide-in-from-bottom-5" data-id="element-244">
          <img src={IMAGES.TOMO_1} alt="Prodotto" className="w-12 h-16 object-cover rounded shadow-sm" data-id="element-245" />
          <div data-id="element-246">
            <p className="text-sm font-bold text-gray-900" data-id="element-247">
              {randomPerson.name} da {randomPerson.city}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-248">
              Ha appena acquistato questo prodotto
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-249">Qualche istante fa</p>
          </div>
        </div>, {
      duration: 4000,
      position: 'bottom-left'
    });
    // Schedule next popup between 15 and 30 seconds
    const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
    timeoutRef.current = setTimeout(showRandomPopup, nextDelay);
  };
  return null; // This component just manages the toast logic
}